import { CustomerDataModelShort } from '@/account/data/models/customer';

export const transformDobCustomer = (
  customerData: CustomerDataModelShort
): CustomerDataModelShort | (CustomerDataModelShort & { dob: string }) => {
  if (!customerData?.dateOfBirth) return customerData;

  const { dateOfBirth, ...rest } = customerData;

  return { ...rest, dob: dateOfBirth } as CustomerDataModelShort & {
    dob: string;
  };
};
